import { AbstractOperationMessage } from "./abstractOperationMessage"

export class AttachmentOperationMessage extends AbstractOperationMessage {

  protected readonly ATTACHMENT_ID = "attachmentId";

  get attachmentId(): number { return this.getInternalValue<number>(this.ATTACHMENT_ID); }
  setAttachmentId(attachmentId: number): this { return this.setInternalValue(this.ATTACHMENT_ID, attachmentId); }
  
}